import './WhatIs.css';

const cards = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <rect x="4" y="4" width="20" height="20" rx="5" fill="#EEF2FD"/>
        <path d="M9 14h10M9 10h6M9 18h8" stroke="#5784E6" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="21" cy="7" r="4" fill="#FFB400"/>
        <path d="M20 7l.8.8L22.5 5.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Not Yükle',
    desc: 'Ders notlarını bölüm, dönem ve ders bilgisiyle birlikte sisteme ekle.',
    accent: '#5784E6',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <rect x="4" y="4" width="20" height="20" rx="5" fill="#EEF2FD"/>
        <path d="M9 14l3 3 7-7" stroke="#5784E6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="21" cy="7" r="4" fill="#FFB400"/>
        <path d="M19.5 7h3M21 5.5v3" stroke="white" strokeWidth="1.2" strokeLinecap="round"/>
      </svg>
    ),
    title: 'Eşleşme Mantığı',
    desc: 'Paylaştığın notlarla sistemdeki uygun notlara daha dengeli şekilde eriş.',
    accent: '#5784E6',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <rect x="4" y="4" width="20" height="20" rx="5" fill="#EEF2FD"/>
        <circle cx="13" cy="13" r="4" stroke="#5784E6" strokeWidth="1.8"/>
        <path d="M16 16l4 4" stroke="#5784E6" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="21" cy="7" r="4" fill="#FFB400"/>
        <path d="M20 7l.8.8L22.5 5.5" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: 'Dersine Göre Bul',
    desc: 'İhtiyacın olan notları ders, bölüm ve dönem filtreleriyle daha kolay keşfet.',
    accent: '#5784E6',
  },
];

export default function WhatIs() {
  return (
    <section className="whatis" id="about">
      <div className="container">
        <div className="whatis__inner">
          <div className="whatis__text">
            <div className="whatis__label">NoteSwapp Nedir?</div>
            <h2 className="whatis__title">
              Ders notlarını paylaşmanın daha akıllı yolu
            </h2>
            <p className="whatis__desc">
              NoteSwapp, ders notlarını daha yapılandırılmış, adil ve güvenilir bir şekilde paylaşmak isteyen öğrenciler için tasarlanmış bir not paylaşım platformudur. Öğrenciler tarafından, öğrenciler için.
            </p>
            <a href="#how-it-works" className="whatis__link">
              Nasıl çalışır? →
            </a>
          </div>

          <div className="whatis__cards">
            {cards.map((card, i) => (
              <div className="whatis__card" key={i}>
                <div className="whatis__card-icon">{card.icon}</div>
                <div className="whatis__card-body">
                  <h3 className="whatis__card-title">{card.title}</h3>
                  <p className="whatis__card-desc">{card.desc}</p>
                </div>
                <div className="whatis__card-accent" style={{ background: i === 1 ? '#FFB400' : '#5784E6' }} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
